// src/features/auth/idApi.ts
import { idApi } from '@/store/idApi'

export const authIdApi = idApi.injectEndpoints({
  endpoints: (build) => ({
    checkIdToken: build.query<{ token: string }, void>({
      query: () => ({ url: 'users/get-jwt/', method: 'GET', cache: 'no-store' }),
    }),
    loginByEmail: build.mutation<void, { email: string; redirect_url: string }>({
      query: (body) => ({
        url: 'users/login/',
        method: 'POST',
        body,
        // Mirrors academy-frontend: forces token-in-URL magic-link flow
        // instead of cookie-based redirect (Safari ITP breaks cookies).
        params: { use_verification_code: false },
      }),
    }),
    loginWithOAuth: build.mutation<
      { oauthRedirectTo: string | null },
      { oauth: 'GOOGLE'; redirect_url: string }
    >({
      query: (body) => ({ url: 'users/login/', method: 'POST', body }),
    }),
    exchangeCode: build.mutation<{ token: string }, { code: string }>({
      query: ({ code }) => ({ url: 'users/exchange-code/', method: 'POST', body: { code } }),
    }),
    logout: build.mutation<void, void>({
      query: () => 'users/logout/',
    }),
  }),
})

export const {
  useCheckIdTokenQuery,
  useLoginByEmailMutation,
  useLoginWithOAuthMutation,
  useExchangeCodeMutation,
  useLogoutMutation,
} = authIdApi
